import { useState } from "react";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import CompalintCard from "./CompalintCard";
import { AnimatePresence } from "framer-motion";
import CompalintTable from "./CompalintTable";

const CompalintPage = () => {
    //#region 
    const [isCreate, setIsCreate] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [editData, setEditData] = useState({});
    const [isChanged, setIsChanged] = useState(false);



    const handlePopup = () => {
        setIsCreate(!isCreate); // Toggles the visibility of the MenuCard
        setIsEdit(false); // Reset edit state when toggling the form
        setEditData({}); // Clear edit data when toggling the form
    };

    const handleEdit = (data) => {
        setIsEdit(true);
        setEditData(data);
        setIsCreate(true); // Ensure the form is visible when editing
    }

    //#endregion
    return (
        <>


            <CardHeadMenu
                prefix={"Na"}
                suffix={"Na"}
                title={"Compalint Page"}
                handlePopup={handlePopup}
                create={isCreate}
            />


            <AnimatePresence>
                {isCreate && (
                    <CompalintCard
                        isCreate={isCreate} // State passed as a prop
                        setIsCreate={setIsCreate} // Function passed as a prop
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        editData={editData}
                        setEditData={setEditData}
                        isChanged={isChanged}   
                        setIsChanged={setIsChanged}
                    />
                )}
            </AnimatePresence>

            <CompalintTable
            onEdit={handleEdit} // Pass the handleEdit function as a prop
            isChanged={isChanged}
            />

        </>
    )
}

export default CompalintPage
